/**
 * Point API
 *
 *
*/
import httpService from '@/api/httpService'

const pointApi = {
    // Recent Badge
    // https://clpapi.tinkeredu.co.kr/static/docs/point.html#resources-level-history_http_request
    pointList(params) {
        return httpService.get('/membership/history/point',params)
    },
    pointListType(params) {
        return httpService.get('/membership/history/point',params)
    },
    getPointForGraph(params) {
        return httpService.get('/membership/history/point/graph',params)
    },
    
}

export default pointApi